export const EDIT_MODES = ['md','sm','xs']

export const EDIT_MODES_MAPPING = {
  'mode-md-active': 'md',
  'mode-sm-active': 'sm',
  'mode-xs-active': 'xs',
  default: 'md'
}

export function getEditMode(canvasSizeClass) {
  return EDIT_MODES_MAPPING[canvasSizeClass] || EDIT_MODES_MAPPING.default
}



// WEBPACK FOOTER //
// ./src/constants/EditModes.js